import React from 'react';
import { useFormikContext } from 'formik';

import { stepToFields } from './initialValues';

const stepIndexToFields = Object.values(stepToFields);
let maxStep = 0;

type TouchStepFieldsProps = {
    step: number,
};

const TouchStepFields = ({ step }: TouchStepFieldsProps) => {
    const { setTouched, touched, values } = useFormikContext();
    let nextTouched = { ...touched };
    React.useEffect(() => {
        for (let i = maxStep; i < step; i++) {
            stepIndexToFields[i].forEach(field => {
                // @ts-ignore
                nextTouched[field] = true;
            });
        }

        //Formik doesn't do a good job of activating nested fields activation, so I'm doing it manually here in the appropriate step
        if (step > 6) {
            // @ts-ignore
            const securityClearancesLength = values['securityClearances'] ? values['securityClearances'].length : 0;
            if (securityClearancesLength) {
                //@ts-ignore
                nextTouched['securityClearances'] = [];
            }
            for (var i = 0; i < securityClearancesLength; i++) {
                // @ts-ignore
                nextTouched['securityClearances'][i] = {};
                // @ts-ignore
                nextTouched['securityClearances'][i]['federalAgency'] = true;
                // @ts-ignore
                nextTouched['securityClearances'][i]['clearanceLevel'] = true;
                // @ts-ignore
                nextTouched['securityClearances'][i]['dateOfApproval'] = true;
            }
        }

        if (step > 1) {
            // @ts-ignore
            const ownersLength = values['owners'] ? values['owners'].length : 0;
            if (ownersLength) {
                //@ts-ignore
                nextTouched['owners'] = [];
            }
            for (var i = 0; i < ownersLength; i++) {
                // @ts-ignore
                nextTouched['owners'][i] = {};
                // @ts-ignore
                nextTouched['owners'][i]['name'] = true;
                // @ts-ignore
                nextTouched['owners'][i]['title'] = true;
                // @ts-ignore
                nextTouched['owners'][i]['ownership'] = true;
            }
        }

        if (step > 5) {
            // @ts-ignore
            const professionalsLength = values['professionals'] ? values['professionals'].length : 0;
            if (professionalsLength) {
                //@ts-ignore
                nextTouched['professionals'] = [];
            }
            for (var i = 0; i < professionalsLength; i++) {
                // @ts-ignore
                nextTouched['professionals'][i] = {};
                // @ts-ignore
                nextTouched['professionals'][i]['name'] = true;
                // @ts-ignore
                nextTouched['professionals'][i]['title'] = true;
                // @ts-ignore
                nextTouched['professionals'][i]['phone'] = true;
                // @ts-ignore
                nextTouched['professionals'][i]['email'] = true;
            }

            // @ts-ignore
            const oshaCitationsDetailsLength = values['oshaCitationsDetails'] ? values['oshaCitationsDetails'].length : 0;
            if (oshaCitationsDetailsLength) {
                //@ts-ignore
                nextTouched['oshaCitationsDetails'] = [];
            }
            for (var i = 0; i < oshaCitationsDetailsLength; i++) {
                // @ts-ignore
                nextTouched['oshaCitationsDetails'][i] = {};
                // @ts-ignore
                nextTouched['oshaCitationsDetails'][i]['citationType'] = true;
                // @ts-ignore
                nextTouched['oshaCitationsDetails'][i]['fineAmounts'] = true;
                // @ts-ignore
                nextTouched['oshaCitationsDetails'][i]['abatement'] = true;
                // @ts-ignore
                nextTouched['oshaCitationsDetails'][i]['contact'] = true;
            }
        }

        if (step > 6) {
            // @ts-ignore
            const cageCodesLength = values['cageCodes'] ? values['cageCodes'].length : 0;
            if (cageCodesLength) {
                //@ts-ignore
                nextTouched['cageCodes'] = [];
            }
            for (var i = 0; i < cageCodesLength; i++) {
                // @ts-ignore
                nextTouched['cageCodes'][i] = {};
                // @ts-ignore
                nextTouched['cageCodes'][i]['SSP'] = true;
                // @ts-ignore
                nextTouched['cageCodes'][i]['supportedBySSP'] = true;
                // @ts-ignore
                nextTouched['cageCodes'][i]['dateOfAssessment'] = true;
                // @ts-ignore
                nextTouched['cageCodes'][i]['totalScore'] = true;
                // @ts-ignore
                nextTouched['cageCodes'][i]['estimatedDateOfAchievement'] = true;
            }
        }

        setTouched(nextTouched);

        if (step > maxStep) {
            maxStep = step;
        }
    }, [step]);

    return null;
}

export default TouchStepFields;
